<template>
<div>
  <!--
  <div>END OF DAY: {{this.endOfDay}}</div>
  <div>START OF WEEK: {{this.startOfWeek}}</div>
  <div>END OF WEEK: {{this.endOfWeek}}</div>
  <div>ALL: {{this.routineTaskInstances.length}}</div>
  -->
  <div>
    <div class="text-danger bg-white px-3 pb-3 mb-4 rounded shadow">
      <h5 class="px-2 py-3 mb-0"><strong>Overdue ({{this.tasksOverDue.length}})</strong></h5>
      <!--Table-->
      <div>
        <b-table-simple bordered class="rg-table m-0">
          <b-thead>
            <b-tr>
              <b-th>Task/Inspection Name</b-th>
              <b-th>Location(s)</b-th>
              <b-th class="text-center">Assigned To</b-th>
              <b-th>Due Date</b-th>
              <b-th>Occurrence</b-th>
              <b-th>Status</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
        <b-tbody>
          <b-tr v-for="task in this.tasksOverDue" v-bind:key="task.id">
            <b-td class="emphasis">
              <div>{{ task.routineTask.name }}</div>
            </b-td>
            <b-td>
              <span v-if="task.routineTask.locations.length === 1">
                {{task.routineTask.locations[0].name}}
              </span>
              <b-dropdown v-if="task.routineTask.locations.length > 1" no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                <template #button-content>
                  <span :id="task.id">
                    <span class="fa-stack has-badge" :data-count="task.routineTask.locations.length">
                      <i class="fas fa-map-marker"></i>
                    </span>
                  </span>
                </template>
                <b-dropdown-text class="text-nowrap" v-for="(location, index) in task.routineTask.locations" v-bind:key="location.name">
                  {{location.name}}<span v-if="(index < task.routineTask.locations.length -1)"></span>
                </b-dropdown-text>
              </b-dropdown>
            </b-td>
            <b-td class="text-center">
              <b-dropdown no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                <template #button-content>
                  <span :id="task.id">
                    <span class="fa-stack has-badge" :data-count="task.routineTask.assignedPeopleRealized.length">
                      <i class="fas fa-user"></i>
                    </span>
                  </span>
                </template>
                <b-dropdown-text class="text-nowrap" v-for="(person, index) in task.routineTask.assignedPeopleRealized" v-bind:key="person.id">
                  {{person | fullName}}<span v-if="(index < task.routineTask.assignedPeopleRealized.length -1)"></span>
                </b-dropdown-text>
              </b-dropdown>
              <!-- Display roles -->
              <span v-if="task.routineTask.assignedRolesRealized && task.routineTask.assignedRolesRealized.length > 0">
                <b-dropdown no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                  <template #button-content>
                    <span class="fa-stack has-badge" :data-count="task.routineTask.assignedRolesRealized.length">
                      <i class="fas fa-users fa-stack-1x"></i>
                    </span>
                  </template>
                  <b-dropdown-text v-for="role in task.routineTask.assignedRolesRealized" :key="role.id">
                    {{ role.name }}
                  </b-dropdown-text>
                </b-dropdown>
              </span>
            </b-td>
            <b-td>
              <div>{{ task.dueDateLocal | formatDateNoTime }}</div>
            </b-td>
            <b-td>
              <div>{{ task.routineTask.schedule.routineTaskScheduleType }}</div>
            </b-td>
              <b-td>
                <div>{{ task.status | splitOnUpperCase }}</div>
              </b-td>
            <b-td class="table-action text-center">
              <b-btn
                title="Edit Task"
                @click="$emit('edit-task', task.routineTask)"
                variant="link">
                <i class="fas fa-edit"></i>
              </b-btn>
              <b-btn
                title="View Details"
                @click="$emit('view-task-instance', task.id)"
                variant="link">
                <i class="fas fa-eye"></i>
              </b-btn>
            </b-td>
          </b-tr>
        </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="text-info bg-white px-3 pb-3 mb-4 rounded shadow">
      <h5 class="px-2 py-3 mb-0"><strong>Due week of {{startDate}} ({{this.taskDueThisWeek.length}})</strong></h5>
      <div>
        <b-table-simple bordered class="rg-table mb-0">
          <b-thead>
            <b-tr>
              <b-th>Task/Inspection Name</b-th>
              <b-th>Location(s)</b-th>
              <b-th class="text-center">Assigned To</b-th>
              <b-th>Due Date</b-th>
              <b-th>Occurrence</b-th>
              <b-th>Status</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="task in this.taskDueThisWeek" v-bind:key="task.id">
              <b-td class="emphasis">
                <div>{{ task.routineTask.name }}</div>
              </b-td>
              <b-td>
                <span v-if="task.routineTask.locations.length === 1">
                  {{task.routineTask.locations[0].name}}
                </span>
                <b-dropdown v-if="task.routineTask.locations.length > 1" no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                  <template #button-content>
                    <span :id="task.id">
                      <span class="fa-stack has-badge" :data-count="task.routineTask.locations.length">
                        <i class="fas fa-map-marker"></i>
                      </span>
                    </span>
                  </template>
                  <b-dropdown-text v-for="(location, index) in task.routineTask.locations" v-bind:key="location.name">
                    {{location.name}}<span v-if="(index < task.routineTask.locations.length -1)"></span>
                  </b-dropdown-text>
                </b-dropdown>
              </b-td>
              <b-td class="text-center">
                <b-dropdown v-if="task.routineTask.assignedPeopleRealized.length > 1" no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                  <template #button-content>
                    <span :id="task.id">
                      <span class="fa-stack has-badge" :data-count="task.routineTask.assignedPeopleRealized.length">
                        <i class="fas fa-user"></i>
                      </span>
                    </span>
                  </template>
                  <b-dropdown-text class="text-nowrap" v-for="(person, index) in task.routineTask.assignedPeopleRealized" v-bind:key="person.id">
                    {{person | fullName}}<span v-if="(index < task.routineTask.assignedPeopleRealized.length -1)"></span>
                  </b-dropdown-text>
                </b-dropdown>
                <!-- Display roles -->
                <span v-if="task.routineTask.assignedRolesRealized && task.routineTask.assignedRolesRealized.length > 0">
                  <b-dropdown no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                    <template #button-content>
                      <span class="fa-stack has-badge" :data-count="task.routineTask.assignedRolesRealized.length">
                        <i class="fas fa-users fa-stack-1x"></i>
                      </span>
                    </template>
                    <b-dropdown-text v-for="role in task.routineTask.assignedRolesRealized" :key="role.id">
                      {{ role.name }}
                    </b-dropdown-text>
                  </b-dropdown>
                </span>
              </b-td>
              <b-td>
                <div>{{ task.dueDateLocal | formatDateNoTime }}</div>
              </b-td>
              <b-td>
                <div>{{ task.routineTask.schedule.routineTaskScheduleType }}</div>
              </b-td>
              <b-td>
                <div>{{ task.status | splitOnUpperCase }}</div>
              </b-td>
              <b-td class="table-action text-center">
                <b-btn
                  title="Edit Task"
                  @click="$emit('edit-task', task.routineTask)"
                  variant="link">
                  <i class="fas fa-edit"></i>
                </b-btn>
                 <b-btn
                title="View Details"
                @click="$emit('view-task-instance', task.id)"
                variant="link">
                <i class="fas fa-eye"></i>
                </b-btn>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="text-success bg-white px-3 pb-3 mb-4 rounded shadow">
      <h5 class="px-2 py-3 mb-0"><strong>Completed ({{this.taskCompleted.length}})</strong></h5>
      <!--Table-->
      <div>
        <b-table-simple bordered class="rg-table mb-0">
          <b-thead>
            <b-tr>
              <b-th>Task/Inspection Name</b-th>
              <b-th>Location(s)</b-th>
              <b-th class="text-center">Assigned To</b-th>
              <b-th>Due Date</b-th>
              <b-th>Occurrence</b-th>
              <b-th>Status</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="task in this.taskCompleted" v-bind:key="task.id">
              <b-td class="emphasis">
                <div>{{ task.routineTask.name }}</div>
              </b-td>
              <b-td>
                <span v-if="task.routineTask.locations.length === 1">
                  {{task.routineTask.locations[0].name}}
                </span>
                <b-dropdown class="text-nowrap" v-if="task.routineTask.locations.length > 1" no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                  <template #button-content>
                    <span :id="task.id">
                      <span class="fa-stack has-badge" :data-count="task.routineTask.locations.length">
                        <i class="fas fa-map-marker"></i>
                      </span>
                    </span>
                  </template>
                  <b-dropdown-text v-for="(location, index) in task.routineTask.locations" v-bind:key="location.name">
                    {{location.name}}<span v-if="(index < task.routineTask.locations.length -1)"></span>
                  </b-dropdown-text>
                </b-dropdown>
              </b-td>
              <b-td class="text-center">
                <b-dropdown v-if="task.routineTask.assignedPeopleRealized.length > 1" no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                  <template #button-content>
                    <span :id="task.id">
                      <span class="fa-stack has-badge" :data-count="task.routineTask.assignedPeopleRealized.length">
                        <i class="fas fa-user"></i>
                      </span>
                    </span>
                  </template>
                  <b-dropdown-text class="text-nowrap" v-for="(person, index) in task.routineTask.assignedPeopleRealized" v-bind:key="person.id">
                    <div></div>
                    {{person | fullName}}<span v-if="(index < task.routineTask.assignedPeopleRealized.length -1)"></span>
                  </b-dropdown-text>
                </b-dropdown>
                <!-- Display roles -->
                <span v-if="task.routineTask.assignedRolesRealized && task.routineTask.assignedRolesRealized.length > 0">
                  <b-dropdown no-caret size="sm" variant="light border-lg" toggle-class="text-decoration-none">
                    <template #button-content>
                      <span class="fa-stack has-badge" :data-count="task.routineTask.assignedRolesRealized.length">
                        <i class="fas fa-users fa-stack-1x"></i>
                      </span>
                    </template>
                    <b-dropdown-text v-for="role in task.routineTask.assignedRolesRealized" :key="role.id">
                      {{ role.name }}
                    </b-dropdown-text>
                  </b-dropdown>
                </span>
              </b-td>
              <b-td>
                <div>{{ task.dueDateLocal | formatDateNoTime }}</div>
              </b-td>
              <b-td>
                <div>{{ task.routineTask.schedule.routineTaskScheduleType }}</div>
              </b-td>
              <b-td>
                <div>{{ task.status | splitOnUpperCase }}</div>
              </b-td>
              <b-td class="table-action text-center">
                <b-btn
                  title="Edit Task"
                  @click="$emit('edit-task', task.routineTask)"
                  variant="link">
                  <i class="fas fa-edit"></i>
                </b-btn>
                 <b-btn
                title="View Details"
                @click="$emit('view-task-instance', task.id)"
                variant="link">
                <i class="fas fa-eye"></i>
                </b-btn>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
  <!-- Routine task list modal -->
  <b-modal size="lg" v-model="showModal" title="Routine Task Instances" no-close-on-backdrop no-close-on-esc hide-header-close scrollable>
    <div>
      <b-form v-on:submit.prevent>
      <b-form-group>
        <b-form-select v-model="statusType" :options="taskInstanceOptions" text-field="name" value-field="value"  @change="onSelectOption">
        </b-form-select>
      </b-form-group>
      <div v-for="task in tasksToDisplay" :key="task.id">{{task.routineTask.name}} - {{ task.dueDate.dateTimeUtc | formatDateNoTime }}</div>
      </b-form>
    </div>
    <template v-slot:modal-footer>
        <b-btn variant="light" @click="showModal=false">Close</b-btn>
    </template>
  </b-modal>
</div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Procedures, spr2Validation } from '../mixins/Spr2SharedFunctions'
import moment from 'moment'

export default {
  name: 'RoutineTaskInstances',
  props: {
    propertyId: {
      type: String,
      default: null
    },
    startDate: {
      type: String,
      default: moment().startOf('week').format('MM/DD/YYYY')
    },
    endDate: {
      type: String,
      default: moment().endOf('week').format('MM/DD/YYYY')
    }
  },
  async mounted () {
    await this.doGetRoutineTaskInstances()
  },
  mixins: [spr2Validation, spr2Procedures],
  components: {
  },
  data () {
    return {
      taskInstanceOptions: [{name: 'Overdue', value: 'overdue'}, {name: 'Current', value: 'current'}, {name: 'Upcoming', value: 'upcoming'}, {name: 'Completed', value: 'completed'}],
      routineTaskInstances: [],
      endOfDay: moment().endOf('day').format('MM-DD-YYYY hh:mm'),
      startOfWeek: moment(this.startDate).startOf('week').format('MM-DD-YYYY hh:mm'),
      endOfWeek: moment(this.startDate).endOf('week').format('MM-DD-YYYY hh:mm'),
      statusType: null,
      showModal: false
    }
  },
  computed: {
    tasksOverDue () {
      let tasks = this.routineTaskInstances.filter((task) => {
        let dueDate = moment(task.dueDateLocal, 'YYYY-MM-DD').endOf('day')
        return dueDate.isBefore(moment(this.endOfDay)) && task.status.toLowerCase() !== 'complete'
      })
      return tasks
    },
    taskDueThisWeek () {
      let tasks = this.routineTaskInstances.filter((task) => {
        let dueDate = moment(task.dueDateLocal).endOf('day')
        return dueDate.isAfter(moment(this.startOfWeek)) &&
          dueDate.isBefore(moment(this.endOfWeek)) &&
          dueDate.isAfter(moment(this.endOfDay)) &&
          task.status.toLowerCase() !== 'complete'
      })
      return tasks
    },
    taskCompleted () {
      let tasks = this.routineTaskInstances.filter((task) => {
        return task.status.toLowerCase() === 'complete'
      })
      return tasks
    },
    taskDueLaterThanThisWeek () {
      let tasks = this.routineTaskInstances.filter((task) => {
        let dueDate = moment(task.dueDateLocal).endOf('day')
        return dueDate.isAfter(this.endOfWeek) && task.status.toLowerCase() !== 'complete'
      })
      return tasks
    },
    tasksToDisplay () {
      let tasks = []
      switch (this.statusType) {
        case 'overdue':
          tasks = this.tasksOverDue
          break
        case 'current':
          tasks = this.taskDueThisWeek
          break
        case 'upcoming':
          tasks = this.taskDueLaterThanThisWeek
          break
        case 'completed':
          tasks = this.taskCompleted
          break
      }
      return tasks
    }
  },

  methods: {
    ...mapActions('routineTasks', ['getRoutineTaskInstances']),

    async doGetRoutineTaskInstances () {
      // console.log('prop id', this.propertyId)
      await this.getRoutineTaskInstances({propertyId: this.propertyId, startDate: this.startDate, endDate: this.endDate}).then((result) => {
        // console.log('RESULT', result.instances)
        this.routineTaskInstances = result.instances
      })
    },
    async showTaskInstances (statusType) {
      this.statusType = statusType
      this.showModal = true
      // console.log(status, this.propertyId)
      // alert('Status: ' + status + ', Property: ' + this.propertyId + ', Modal coming soon...')
    },
    async onSelectOption (option) {
      this.statusType = option.toLowerCase()
    }
  },
  emits: ['editTask'],
  filters: {
    splitOnUpperCase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.match(/[A-Z][a-z]+|[0-9]+/g).join(' ')
    }
  }
}
</script>

<style scoped>
.fa-stack[data-count]:after{
  position:absolute;
  left:60%;
  bottom:-0.25em;
  content: attr(data-count);
  font-size:75%;
  padding:.4em;
  border-radius:999px;
  line-height:1em;
  color: white;
  background:rgb(55, 163, 220);
  text-align:center;
  min-width:2em;
  font-weight:bold;
  border: 1px solid white;
}

.b-dropdown-text {
  min-width: 200px;
  cursor: default;
}
</style>
